// src/stone/illustrations/MachineTabletIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var MachineTabletIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { width: 64, height: 64, fill: "#E8FEF3", rx: 4 }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m9.077 33.705.966 3.95.197.808.105.43 3.713 15.188a2.684 2.684 0 0 0 3.245 1.97l10.567-2.584a2.68 2.68 0 0 0 1.97-3.244l-4.982-20.375a2.684 2.684 0 0 0-3.244-1.97l-5.528 1.352-5.038 1.232a2.685 2.685 0 0 0-1.97 3.243"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m9.077 33.705.966 3.95 5.237-4.744 2.282-2.07c-.274-.188-.826-.814-1.475-1.61l-5.04 1.23a2.685 2.685 0 0 0-1.97 3.244M10.24 38.463l.105.43 4.53-4.063c.079-.072.052-.216-.02-.279-.088-.073-.198-.05-.278.02-.5.452-1.006.903-1.507 1.353z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#008E5A",
          d: "m20.229 55.335 11.444-2.798a2.3 2.3 0 0 0 1.686-2.778l-5.164-21.124a2.3 2.3 0 0 0-2.777-1.686l-11.445 2.797a2.3 2.3 0 0 0-1.687 2.778L17.45 53.65a2.3 2.3 0 0 0 2.779 1.686"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "m18.901 51.708 12.277-3.002-4.438-18.152-12.277 3.001z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "m26.373 31.158 4.2 17.181-.64.157-4.2-17.181z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M20.139 30.726a.56.56 0 1 0 0-1.122.56.56 0 0 0 0 1.122M33.791 54.85a.088.088 0 0 1 .13-.069c2.385 1.248 4.659 1.817 6.758 1.69 1.875-.114 3.518-.794 4.753-1.968 1.12-1.066 1.843-2.478 2.087-4.08.254-1.666-.027-3.453-.813-5.17a.088.088 0 1 1 .161-.074c.8 1.748 1.086 3.57.828 5.27-.25 1.643-.99 3.089-2.14 4.183-1.265 1.202-2.947 1.9-4.864 2.016-2.132.129-4.437-.447-6.851-1.71a.09.09 0 0 1-.049-.088"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#1D232A", d: "m47.687 45.123-1.203-.47-.196 1.308z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M46.2 45.952v-.004l.195-1.308a.1.1 0 0 1 .043-.063.09.09 0 0 1 .076-.006l1.203.47a.09.09 0 0 1 .056.076.09.09 0 0 1-.042.083l-1.398.837a.088.088 0 0 1-.133-.085m.354-1.176-.151 1.013 1.083-.649zM28.407 17.06a.088.088 0 0 1-.134.06c-2.296-1.406-4.527-2.125-6.63-2.14-1.878-.012-3.563.557-4.873 1.645-1.19.99-2.005 2.349-2.357 3.932-.365 1.644-.204 3.447.465 5.212a.089.089 0 0 1-.166.063c-.68-1.798-.844-3.635-.472-5.313.36-1.623 1.195-3.016 2.416-4.03 1.342-1.116 3.067-1.699 4.987-1.686 2.137.014 4.398.743 6.722 2.166.033.02.048.056.042.09"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#1D232A", d: "m13.89 25.833 1.17.55.282-1.293z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M15.43 25.105v.004l-.283 1.292a.1.1 0 0 1-.047.06.09.09 0 0 1-.076.001l-1.17-.55a.089.089 0 0 1-.002-.159l1.45-.742a.088.088 0 0 1 .128.094m-.432 1.15.218-1-1.124.574z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M23.107 43.209c.019.089.11.14.195.117a2.606 2.606 0 0 0-1.105-5.085.156.156 0 0 0-.128.188l.208.954a.18.18 0 0 0 .194.14 1.303 1.303 0 0 1 .549 2.53.18.18 0 0 0-.119.205zM21 39.878a.163.163 0 0 0-.224.048l-.699 1.211a.322.322 0 0 0 .095.43l1.138.812a.163.163 0 0 0 .225-.048.16.16 0 0 0 .021-.124l-.484-2.23a.18.18 0 0 0-.072-.1"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E09661",
          d: "M44.626 40.024c-.961.442-1.934.887-2.971 1.1s-2.16.174-3.096-.32c-.936-.492-1.638-1.499-1.574-2.554"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m41.798 41.312-.1.021c-.852.174-2.105.258-3.237-.339-1.076-.566-1.752-1.672-1.686-2.755a.21.21 0 0 1 .224-.198.21.21 0 0 1 .199.224c-.057.918.53 1.865 1.46 2.354 1.021.54 2.171.46 2.955.299 1.02-.208 1.988-.655 2.926-1.085a.213.213 0 0 1 .177.387c-.93.424-1.89.866-2.918 1.092"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M54.052 20.282C53 22.3 50.51 25.341 49.672 27.291l-6.817 19.046c-.432 1.004-1.65 1.597-2.723 1.326l-6.448-1.637 8.611-33.64 8.927 2.265c2.614.664 3.88 3.186 2.83 5.631"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m45.576 17.5-11.89 28.528 6.446 1.635c1.072.273 2.292-.32 2.724-1.325l6.817-19.047zM49.488 25.329a.213.213 0 0 1-.246-.136l-2.723-7.625a.213.213 0 0 1 .4-.143l2.724 7.625a.214.214 0 0 1-.129.272z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m39.001 45.043 7.86-31.498-9.617-2.44c-2.38-.605-5.054.918-5.64 3.213l-6.895 27.73c-.229.92.306 1.777 1.26 2.02l10.21 2.59c1.193.304 2.534-.463 2.822-1.615"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "m42.243 24.29-.002.006-2.972 11.977c-.026.092-.108.203-.266.283a.76.76 0 0 1-.52.063l-9.53-2.41a.43.43 0 0 1-.254-.158.2.2 0 0 1-.03-.177l.001-.006 2.974-11.978c.025-.093.108-.203.265-.283a.76.76 0 0 1 .52-.061l9.53 2.41a.43.43 0 0 1 .254.157q.055.077.03.177Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m45.267 13.14 6.15 1.561c-2.38-.604-5.054.92-5.64 3.213l-1.355-2.809z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m26.18 41.202 1.325-4.917c.11-.423.547-.646 1.027-.525l9.512 2.396c.594.15 1.006.755.872 1.278l-1.327 4.917c-.11.423-.547.646-1.027.525L27.05 42.48c-.594-.15-1.007-.756-.87-1.278"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m26.573 37.26-.105.412 12.766 3.218.104-.411zM26.334 39.822l-.104.41 8.293 2.092.104-.412z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m35.631 37.245-2.01 7.294.41.112 2.01-7.294zM31.128 36.11l-2.01 7.295.41.112 2.01-7.294zM43.963 20.236l.992-3.367c.225-.766-.368-1.547-1.372-1.801l-8.21-2.084c-1.145-.29-2.355.213-2.613 1.086"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M44.008 20.443a.212.212 0 0 1-.249-.268l.993-3.368a.97.97 0 0 0-.099-.766c-.205-.36-.614-.64-1.12-.769l-8.211-2.084c-1.03-.261-2.132.178-2.356.941a.212.212 0 1 1-.408-.12c.29-.989 1.605-1.554 2.869-1.233l8.21 2.084c.62.157 1.124.51 1.386.97.198.349.246.726.138 1.096l-.993 3.367a.22.22 0 0 1-.16.15"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#E8E9EA", d: "M46.267 7.434h-.006V7.43z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E8E9EA",
          d: "M51.86 10.41s-9.47-.374-9.154 12.253v.021l-9.94-2.522-.478-.121c-1.422-9.906 5.58-14.45 10.939-13.73l.009.003.04.853 2.984.264.047.861 2.952.244.006.002.067.914z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M42.752 22.892a.2.2 0 0 1-.098-.002l-10.418-2.643a.212.212 0 1 1 .104-.411l10.417 2.644a.21.21 0 0 1 .154.257.21.21 0 0 1-.159.155M46.266 7.432h-.005v-.006z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M36.013 33.362a4.096 4.096 0 0 0 3.127-4.877 4.097 4.097 0 0 0-4.882-3.12 4.097 4.097 0 0 0-3.127 4.877 4.096 4.096 0 0 0 4.882 3.12"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M46.266 7.432h-.005v-.006zM34 31.033a.21.21 0 0 1-.228-.1l-1.015-1.698a.212.212 0 0 1 .366-.218l.905 1.517 3.494-2.082a.213.213 0 1 1 .218.365l-3.678 2.19a.2.2 0 0 1-.062.025"
        }
      )
    ]
  }
);
var MachineTabletIllustration_default = MachineTabletIllustration;

export {
  MachineTabletIllustration,
  MachineTabletIllustration_default
};
